import { useCallback, useState } from "react"
import { useSelector } from "react-redux"
import { toast } from "sonner"
import { selectCurrentOrganizationId } from "@/modules/organizations/store/organizationSlice"
import { getCandidateCvDownloadUrl } from "../infrastructure/candidate-service"

/**
 * Opens a candidate's CV in a new tab using a SAS URL requested at click time.
 * The tab is opened synchronously (before the request) so popup blockers allow it.
 */
export function useOpenCandidateCv() {
  const organizationId = useSelector(selectCurrentOrganizationId)
  const [openingCandidateId, setOpeningCandidateId] = useState<string | null>(
    null,
  )

  const openCv = useCallback(
    async (candidateId: string) => {
      const tab = window.open("", "_blank")
      if (tab) tab.opener = null
      setOpeningCandidateId(candidateId)
      try {
        const { sasUrl } = await getCandidateCvDownloadUrl(
          organizationId,
          candidateId,
        )
        if (!sasUrl) throw new Error("Download URL not available")
        if (tab) {
          tab.location.href = sasUrl
        } else {
          window.open(sasUrl, "_blank", "noopener,noreferrer")
        }
      } catch {
        tab?.close()
        toast.error("Failed to open CV")
      } finally {
        setOpeningCandidateId(null)
      }
    },
    [organizationId],
  )

  return { openCv, openingCandidateId }
}
